import { Button, Modal, Select, Upload } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import CustomIcon from '../../../components/IconUser'
import { AttachTypeEnum } from '../../../global/enum/categoryQualification'
import { APTITUDE_ACCEPT } from './helpers'
import useUploadModal from './hooks'
import { UploadModalProps } from './typing'
import Style from './aptitudeAttach.module.scss'

const { Dragger } = Upload

// 「批量上传」资质文件弹框
const UploadModal = (props: UploadModalProps) => {
  const { open, onCancel } = props
  const {
    attachType,
    setAttachType,
    stagedFiles,
    uploading,
    beforeUpload,
    onRemoveStaged,
    onConfirm,
  } = useUploadModal(props)

  return (
    <Modal
      open={open}
      title="批量上传"
      destroyOnClose
      maskClosable={false}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>,
        <Button key="ok" type="primary" loading={uploading} onClick={onConfirm}>
          确定
        </Button>,
      ]}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        <span style={{ width: 110, textAlign: 'right', flexShrink: 0 }}>
          <span style={{ color: '#ff4d4f' }}>*</span> 图片资质类型：
        </span>
        <Select
          style={{ flex: 1 }}
          placeholder="请选择图片资质类型"
          value={attachType}
          onChange={setAttachType}
          options={AttachTypeEnum.map((item) => ({
            label: item.label,
            value: item.value,
          }))}
        />
      </div>

      <Dragger
        accept={APTITUDE_ACCEPT}
        multiple
        showUploadList={false}
        beforeUpload={beforeUpload}
        disabled={uploading}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">点击或拖拽文件到此处</p>
        <p className={Style.draggerHint}>支持: jpg / png / pdf</p>
        <p className={Style.draggerHint}>单文件 ≤ 10MB · 数量不限</p>
      </Dragger>

      {stagedFiles.length > 0 && (
        <div className={Style.stagedList}>
          {stagedFiles.map((item) => (
            <div className={Style.stagedItem} key={item.url}>
              <CustomIcon type="icon-wenjian1" style={{ fontSize: '18px' }} />
              <span className={Style.stagedName} title={item.name}>
                {item.name}
              </span>
              <CustomIcon
                type="icon-shanchu1"
                className={Style.delIcon}
                onClick={() => onRemoveStaged(item)}
              />
            </div>
          ))}
        </div>
      )}
    </Modal>
  )
}

export default UploadModal
import { Button, Modal, Select, Upload } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import CustomIcon from '../../../components/IconUser'
import { AttachTypeEnum } from '../../../global/enum/categoryQualification'
import { APTITUDE_ACCEPT } from './helpers'
import useUploadModal from './hooks'
import { UploadModalProps } from './typing'
import Style from './aptitudeAttach.module.scss'

const { Dragger } = Upload

// 「批量上传」资质文件弹框
const UploadModal = (props: UploadModalProps) => {
  const { open, onCancel } = props
  const {
    attachType,
    setAttachType,
    stagedFiles,
    uploading,
    beforeUpload,
    onRemoveStaged,
    onConfirm,
  } = useUploadModal(props)

  return (
    <Modal
      open={open}
      title="批量上传"
      destroyOnClose
      maskClosable={false}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>,
        <Button key="ok" type="primary" loading={uploading} onClick={onConfirm}>
          确定
        </Button>,
      ]}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        <span style={{ width: 110, textAlign: 'right', flexShrink: 0 }}>
          <span style={{ color: '#ff4d4f' }}>*</span> 图片资质类型：
        </span>
        <Select
          style={{ flex: 1 }}
          placeholder="请选择图片资质类型"
          value={attachType}
          onChange={setAttachType}
          options={AttachTypeEnum.map((item) => ({
            label: item.label,
            value: item.value,
          }))}
        />
      </div>

      <Dragger
        accept={APTITUDE_ACCEPT}
        multiple
        showUploadList={false}
        beforeUpload={beforeUpload}
        disabled={uploading}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">点击或拖拽文件到此处</p>
        <p className={Style.draggerHint}>支持: jpg / png / pdf</p>
        <p className={Style.draggerHint}>单文件 ≤ 10MB · 数量不限</p>
      </Dragger>

      {stagedFiles.length > 0 && (
        <div className={Style.stagedList}>
          {stagedFiles.map((item) => (
            <div className={Style.stagedItem} key={item.url}>
              <CustomIcon type="icon-wenjian1" style={{ fontSize: '18px' }} />
              <span className={Style.stagedName} title={item.name}>
                {item.name}
              </span>
              <CustomIcon
                type="icon-shanchu1"
                className={Style.delIcon}
                onClick={() => onRemoveStaged(item)}
              />
            </div>
          ))}
        </div>
      )}
    </Modal>
  )
}

export default UploadModal
